import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featuredArticles = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-[var(--font-heading)] mb-3">
              最新使用教程
            </h2>
            <p className="text-foreground-600 text-sm md:text-base">
              精选最新发布的使用指南与教程文章
            </p>
          </div>
          <Link
            to="/category/guide"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300 flex flex-col"
            >
              <div className="relative h-44 md:h-48 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2 flex-wrap">
                  {article.tags.slice(0, 2).map((tag) => (
                    <span
                      key={tag}
                      className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <h3 className="text-base font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400 mt-auto">
                  <span>{article.date}</span>
                  <span>{article.readTime} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/guide"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部教程
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}